import { createContext } from '@shared/utils/createContext';
import type { GuestIdentificationDialogContextValue } from './GuestIdentificationDialog.types';

// Uses the shared createContext helper so missing-provider crashes are reported
// to New Relic (see NREG-3036).
const [GuestIdentificationDialogContextProvider, useGuestIdentificationDialogContext, GuestIdentificationDialogContext] = createContext<GuestIdentificationDialogContextValue>({
  name: 'GuestIdentificationDialog',
});

export { GuestIdentificationDialogContext, GuestIdentificationDialogContextProvider, useGuestIdentificationDialogContext };
